export enum BedBlockStrength {
  Soft = 'soft', // blocking cause can be lifted if necessary
  Medium = 'medium', // blocking cause can be lifted but not desirable
  Hard = 'hard', // blocking cause cannot be lifted
}
